import Create from './createStorm';
import Edit from './editStorm';
import View from './viewStorm';
import Form from './stormForm';
import StormsContainer from './stormsContainer';

var Storm = {
	Create,
	Edit,
	View,
	Form,
	StormsContainer
}

export default Storm;



// WEBPACK FOOTER //
// ./src/browser/components/storms/index.js